import { FunctionComponent, ReactNode } from "react";

import { classNames } from "@/utils/classNames";

interface SettingsBoxProps {
	title: ReactNode;
	/** Controls beside the title: a toggle, a link button, a count. */
	actions?: ReactNode;
	/** Rendered at the far right of the header row. */
	trailing?: ReactNode;
	children: ReactNode;
	className?: string;
	testId?: string;
	/** Tints the header while the box is switched off. */
	inactive?: boolean;
}

/**
 * The mockup's settings card (PREC-4055): a header row with the title and its
 * controls, and a padded body. Used by every settings tab.
 */
export const SettingsBox: FunctionComponent<SettingsBoxProps> = ({
	title,
	actions,
	trailing,
	children,
	className,
	testId,
	inactive = false,
}) => (
	<div
		className={classNames(
			"mb-3 overflow-hidden rounded-xl border border-border-light bg-white shadow-sm",
			className
		)}
		data-testid={testId}
	>
		<div
			className={classNames(
				"flex items-center gap-2.5 border-b border-border-light px-4 py-3",
				inactive && "bg-background-warning"
			)}
		>
			<h3 className="text-sm font-semibold text-text">{title}</h3>
			{actions}
			{trailing && <div className="ml-auto flex items-center gap-2">{trailing}</div>}
		</div>
		<div className="px-4 py-3.5">{children}</div>
	</div>
);
